<template>
  <div>
    <b-modal
      ref="modalGpt"
      title="Conversa com GPTevan"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div id="gpt-assistant">
        <div
          ref="conversation"
          class="conversation"
        >
          <transition name="fade">
            <div
              v-if="conversation.length > 0"
              class="watermark"
            >
              <img
                class="imgGeniusPermanent"
                :src="require('@/assets/images/pages/genio.png')"
              />
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="conversation.length === 0"
              class="initialText"
            >
              <p>
                Faça suas perguntas ao Hafid<br />
                O Assistente <span class="font-weight-bold">GPTevan</span> responderá.
              </p>

              <img
                class="imgGeniusPresentation"
                :src="require('@/assets/images/pages/genio.png')"
              />
              <div class="elipse"></div>
            </div>
          </transition>

          <div
            v-for="text in conversation"
            :key="text.id"
            class="box"
            :class="`${text.side}`"
          >
            <span v-if="text.side === 'right'">Consultor <small> às {{ text.date }}</small></span>
            <span v-if="text.side === 'left'">Assistente GPTevan <small> às {{ text.date }}</small></span>
            <p>{{ text.message }}</p>

            <div class="d-flex justify-content-end">
              <b-button
                class="btn-use-text"
                size="sm"
                variant="flat-secondary"
                @click="useText(text.id)"
              >
                Usar este texto
              </b-button>
            </div>

          </div>

          <div
            v-if="isLoading"
            class="box awaiting-gpt"
          >
            <div>
              <span>GPT</span>

              <div>
                <p>
                  Carregando...

                  <b-spinner
                    small
                  />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom">
          <b-form-textarea
            ref="inputConversationText"
            v-model="conversationText"
            :disabled="isLoading"
            type="text"
            :placeholder="placeholderText"
            :style="{height: textareaHeight}"
            @keydown="keydown"
          />

          <a
            class="iconSend align-items-center d-flex"
            title="CTRL + Enter"
            @click="sendMessage"
          >
            <feather-icon
              icon="SendIcon"
              stroke="#21C1F4"
              size="24"
            />
          </a>
        </div>
      </div>
    </b-modal>

    <div
      v-if="isHml"
      class="divGpt d-flex justify-content-center align-items-center"
      :class="{disabled: !userId || userId === 0}"
      @click="openModal"
    >
      <img
        ref="imageGenius"
        class="imgGenius"
        :src="require('@/assets/images/pages/genio.png')"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BButton,
  BFormTextarea,
  BSpinner,
} from 'bootstrap-vue'
import toast from '@/mixins/toast'
import SusiService from '@/services/susiService'
import moment from 'moment'

export default {
  name: 'GptAssistant',
  components: {
    BButton,
    BSpinner,
    BFormTextarea,
  },
  mixins: [
    toast,
  ],
  props: {
    userId: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      isHml: false,
      isLoading: false,
      conversationText: '',
      conversation: [],
      userData: {},
    }
  },
  computed: {
    textareaHeight() {
      const len = this.conversationText.split('\n').length * 22 + 28
      if (len < 64) {
        return '64px'
      }
      return `${len}px`
    },
    placeholderText() {
      if (this.isLoading) {
        return 'Processando mensagem no GPT, aguarde...'
      }
      if (this.conversation.length === 0) {
        return 'Insira aqui a sua dúvida'
      }

      return 'Continue sua conversa...'
    },
  },

  watch: {
  },

  async created() {
    this.isHml = document.URL.indexOf('hml-cms.hafidme') > -1 || document.URL.indexOf('localhost') > -1 || document.URL.indexOf('127.0.0.1') > -1

    const userDataString = await localStorage.getItem('userData')
    this.userData = await JSON.parse(userDataString)
  },

  methods: {
    useText(textId) {
      this.$emit('selected-text', this.conversation[textId].message)
    },

    keydown(e) {
      if (e.keyCode === 13 && e.ctrlKey) {
        this.sendMessage()
      }
    },

    sendMessage() {
      if (this.isLoading || this.conversationText.length < 2) {
        return
      }

      const message = this.conversationText
      this.conversation.push({
        id: this.conversation.length,
        side: 'right',
        date: moment().format('HH:mm:ss'),
        message: this.conversationText,
      })

      this.conversationText = ''
      this.isLoading = true
      setTimeout(() => {
        this.$refs.conversation.scrollTop = this.$refs.conversation.scrollHeight
      }, 100)

      SusiService.chatWithAssistant(
        `hafidme-genius-${this.userData.id}-${this.userId}`,
        'asst_WWwrudhAJdIDiParKooiDVI6',
        message,
      ).then(response => {
        this.conversation.push({
          id: this.conversation.length,
          side: 'left',
          date: moment().format('HH:mm:ss'),
          message: response.data.data,
        })
      }).catch(() => {
        this.conversation.push({
          id: this.conversation.length,
          side: 'left',
          date: moment().format('HH:mm:ss'),
          message: 'Erro ao acessar o GPT, tente novamente.',
        })
      }).finally(() => {
        this.isLoading = false
        setTimeout(() => {
          this.$refs.conversation.scrollTop = this.$refs.conversation.scrollHeight
          this.$refs.inputConversationText.focus()
        }, 100)
      })
    },

    openModal() {
      if (this.userId !== 0) {
        this.$refs.modalGpt.show()
      } else {
        this.toastInfo('Aguarde o carregamento da tela.')
      }
    },
  },
}
</script>

<style lang="scss">
  #gpt-assistant {
    .conversation {
      max-height: 500px;
      min-height: 300px;
      overflow-y: auto;
      margin-bottom: 40px;

      .box {
        width: 100%;
        padding: 5px 10px;
        border: 1px solid transparent;

        .btn-use-text {
          display: none;
        }

        &.left .btn-use-text {
          display: block;
        }

        &:last-child {
          border: 1px solid #BBBBBB;
          border-radius: 10px;

          //.btn-use-text {
          //  display: block;
          //}
        }

        &:hover {
          border: 1px solid #BBBBBB;
          border-radius: 10px;
        }

        span {
          display: block;
          font-size: 12px;
          font-weight: 600;

          small {
            font-size: 10px;
          }
        }

        p {
          width: 80%;
          margin-left: 10px;
          white-space: pre-wrap;
        }

        &.awaiting-gpt{
          p {
            width: auto;
          }

          .spinner-border {
            display: inline-block;
            margin-left:10px
          }
        }
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-content: center;
      margin-bottom: 20px;

      .iconSend {
        cursor: pointer;
      }

      textarea {
        width: 95%;
        border-radius: 8px;
        border: 1px solid #999;
        font-size: 14px;
        padding: 5px 10px;
      }
    }

    @keyframes presentation {
      0% {
        transform: scaleX(1) scaleY(1);
      }

      50% {
        transform: scaleX(1.05) scaleY(1.05) translateY(-10px);
      }

      100% {
        transform: scaleX(1) scaleY(1);
      }
    }

    @keyframes presentationShadow {
      0% {
        transform: scaleX(1) scaleY(1);
      }

      50% {
        transform: scaleX(1.1) scaleY(1.1);
      }

      100% {
        transform: scaleX(1) scaleY(1);
      }
    }

    .imgGeniusPermanent {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 50px;
      height: 50px;
      opacity: 0.5;
    }

    .imgGeniusPresentation {
      width: 150px;
      height: 150px;
      animation: presentation 3s linear infinite;
    }

    .initialText {
      width: 300px;
      position: absolute;
      left: 50%;
      margin-left: -150px;
      font-size: 16px;
      text-align: center;
      margin-top: 50px;
    }

    .elipse {
      margin-left: 36%;
      top: 187px;
      width: 83px; /* Largura do elemento */
      height: 25px; /* Altura do elemento */
      background-color: rgba(0, 0, 0, 0.05); /* Cor de fundo da elipse */
      border-radius: 50%; /* Faz com que as bordas se curvem formando uma elipse */
      animation: presentationShadow 3s linear infinite;
      //box-shadow: 2px 2px 5px rgba(0,0,0,0.3);
    }
  }

  .divGpt{
    cursor: pointer;
    position:fixed;
    width: 70px;
    height: 70px;
    z-index: 999;
    right: 10px;
    bottom: 10px;
    background: radial-gradient(circle,rgba(169, 226, 245, 1) 0%, rgba(230, 247, 247, 1) 100%);
    border-radius: 50%;
    border: 1px solid #21C1F4;

    .imgGenius {
      width: 50px;
      height: 50px;
      transition: transform 0.15s ease-in;
    }

    &:not(.disabled) {
      .imgGenius:hover {
        transform: scaleX(1.5) scaleY(1.5);
      }
    }

    &.disabled {
      opacity: 0.5;
    }
  }
</style>
